import { Modal } from 'bootstrap';
import { removeUrlParams } from './misc.js';

// track edited form
//import { Modal } from 'bootstrap';

const changed_form = document.querySelector('.form-save-change');
//const alert_modal = document.getElementById('alert_modal_form');

var form_edited = false;

if (changed_form) {
    // pdf upload??
    changed_form.addEventListener('change', function() {
        form_edited = true;
    });
}
// remove track on submit
window.addEventListener("submit", function() {
    form_edited = false;
});
// changes to forms - alert speichern
window.addEventListener('beforeunload', function (e) {
    if (form_edited === true) {
        e.preventDefault();
        e.returnValue = '';
        //myModal.show;
        //const modalToggle = document.getElementById('alert_modal_form'); myModal.show(modalToggle);
        //var confirmationMessage = 'Das Formular wurde geändert.Wenn Sie die Seite verlassen, werden die Änderungen nicht gespeichert!';
       // (e || window.event).returnValue = confirmationMessage; //Gecko + IE
       // return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    }
});
// check date before submit
const submit_buttons = document.querySelectorAll('button[type="submit"]');

// modals
const modals = document.querySelectorAll('.modal');

// edit modal - spesen, rapport, transport
const edit_form = document.getElementById("edit_modal_form");

const send_addedit_url = "/de/requests/edit-modal/";

// send new and delete url
const send_form_url = "/de/requests/modal/";

// is Form Einsatzplanung
const form_planung = document.querySelectorAll('.pl-add-botschafter');

// delete
const delete_buttons = document.querySelectorAll('.delete-btn');
// delete einsatz
const delete_einsatz_btn = document.querySelector('.delete-einsatz');
// edit
const switch_toggles = document.querySelectorAll('.switch_toggles');


// textarea autoresize
const form_textareas_fields = document.querySelectorAll('[data-autoresize]');

// date validation
function dateIsValid(date) {
  return date instanceof Date && !isNaN(date);
}
function dateCompare(datestart, dateend) {
  return date instanceof Date && !isNaN(date);
}
function datePreSaveValidation(date_start, date_end) {
    var isValid = true;
    var alert1 = document.getElementById('alert-date1');
    var alert2 = document.getElementById('alert-date2');
    if (date_start && date_end) {
        date_start = date_start.value;
        date_end = date_end.value;
        if (dateIsValid(new Date(date_start)) && dateIsValid(new Date(date_end))) {
            // date start end check
            var start = new Date(date_start);
            var end = new Date(date_end);
            if (start.getTime() > end.getTime()) {
                isValid = false;
                if (alert1) {
                    alert1.style.display = 'block';
                } 
            }
            else {
                alert1.style.display = 'none';
            }
            // day amount check
            var diff = end.getTime() - start.getTime();
            var daydiff = diff / (1000 * 60 * 60 * 24);   
            if (daydiff > 28) {
                isValid = false;
                if (alert2) {
                    alert2.style.display = 'block';
                }
            } else {
                alert2.style.display = 'none';
            }
        }
    }
  return isValid;
}

// new add data
function sendFormData(form) {
    const XHR = new XMLHttpRequest();

    // Bind the FormData object and the form element
    const FD = new FormData(form);
    // forms without reload
    const noReload = form.classList.contains('no-reload');

    var response_json, data;
    // Define what happens on successful data submission
    XHR.addEventListener("load", (event) => {
      response_json = event.target.responseText;
      data = JSON.parse(response_json);
      console.log(data);
      if (data.message === true) {
        // reset form
        form.reset();
        // reload page
        if (noReload) {
            if (form.classList.contains('pl-add-botschafter')) {
                // botschafter einsatzplanung
                var card_body = form.querySelector('.card-body');
                var card_btn_save = form.querySelector('.save-btn');
                var card_btn_delete = form.querySelector('.delete-btn');
                // bg farbe ändern
                if (card_body) {
                    card_body.classList.add("bg-secondary");
                    if (card_body.classList.contains('bg-light')) {
                        card_body.classList.remove("bg-light"); 
                    }
                }
                // anmelde btn ausblenden, abmelden einblenden
                if (card_btn_save) {
                    card_btn_save.style.display = 'none';
                    card_btn_delete.style.display = 'block';
                    // add id from the result!
                    if (data.newid > 0) {
                        card_btn_delete.dataset.id = parseInt(data.newid);
                    }
                }
            }
        } else {
            window.location.reload();
        }
        // or add with ajax ...
        // and close modal
        //form_obj = document.querySelector('#'+data.name+'_add_modal');
        //form_modal = bootstrap.Modal.getInstance(form_obj);    
        //form_modal.hide();
      };
       
    });

    // Define what happens in case of error
    XHR.addEventListener("error", (event) => {
      alert('Oops! Something went wrong.');
    });

    // Set up our request
    XHR.open("POST", send_form_url, true);

    // The data sent is what the user provided in the form
    XHR.send(FD);
}

// edit, delete data
function sendEditData(id, tb, field, val, action, element) {
    const XHR = new XMLHttpRequest();
    const noReload = document.querySelectorAll('.no-reload');

    var response_json, data;
    // Define what happens on successful data submission
    XHR.addEventListener("load", (event) => {
      response_json = event.target.responseText;
      data = JSON.parse(response_json);
      if (data.message === true && action == 'delete') {
        //console.log(data);
        // is form planung - nodelist
        if (form_planung.length > 0) {
            var button_parent = field.parentElement;
            if (button_parent) {
                // change styles
                var card_body = button_parent.querySelector('.card-body');
                var card_btn_save = button_parent.querySelector('.save-btn');
                var card_btn_delete = button_parent.querySelector('.delete-btn');
                // bg farbe ändern
                if (card_body) {
                    card_body.classList.add("bg-light");
                    if (card_body.classList.contains('bg-light')) {
                        card_body.classList.remove("bg-secondary"); 
                    }
                }
                // anmelde btn ausblenden, abmelden einblenden
                if (card_btn_save) {
                    card_btn_save.style.display = 'block';
                    card_btn_delete.style.display = 'none';
                    // set back to 0 - keine Verknüpfung
                    card_btn_delete.dataset.id = 0;
                }
            }
            // reset field
            field = '';
        } else {
            // reload page
            window.location.reload();
        }
      };
    });

    // Define what happens in case of error
    XHR.addEventListener("error", (event) => {
      alert('Daten konnten nicht übermittelt werden.');
    });

    // Set up our request
    XHR.open("POST", send_form_url, true);
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    XHR.send('action='+action+'&id='+id+'&tb='+encodeURIComponent(tb)+'&field='+encodeURIComponent(field)+'&val='+encodeURIComponent(val));
}

/* textarea autoresize */
function addAutoResize() {
  form_textareas_fields.forEach(function (element) {
    element.style.boxSizing = 'border-box';
    var offset = element.offsetHeight - element.clientHeight;
    // höhe mit text anpassen
    var el_value = element.value;
    if (typeof el_value === 'string' && el_value.trim().length > 0) {
        element.style.height = 'auto';
        element.style.height = element.scrollHeight + offset + 'px';
    }
    // höhe on edit anpassen
    element.addEventListener('input', function (event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + offset + 'px';
    });

    element.removeAttribute('data-autoresize');
  });
}

// zusammenfassung, edit modal
document.onreadystatechange = function () {
    modals.forEach((showModal) => {
    	/* reset forms on abbreachen */
		showModal.addEventListener('hidden.bs.modal', event => {
            removeUrlParams();
			
            var addForm = showModal.querySelector('.reset-form');
            if (addForm) {
                addForm.reset();
            };
		});

    	// show on page load
        if (showModal.classList.contains('show-modal')) {
            // wenn ja entfernen, damit nur einmal aufgerufen wird
            showModal.classList.remove('show-modal');
            //var m_id = showModal.getAttribute('id');
            const thisModal = new Modal(showModal);
            thisModal.show();
        }
    });

    if (edit_form) {
        edit_form.addEventListener('show.bs.modal', event => {
            // get target button
            const button = event.relatedTarget
            // Extract info from data-bs-* attributes
            const edit_id = button.getAttribute('data-id');
            const form_name = button.getAttribute('data-formname');
            const modal_body = edit_form.querySelector('.modal-body');

            // rapport add 
            const planung_id = button.getAttribute('data-planung');
            const planung_date = button.getAttribute('data-date');
            const botschafter_id = button.getAttribute('data-botschafter');

            if (form_name !== '' && edit_id > 0 || form_name !== '' && planung_id > 0) {
                const XHR = new XMLHttpRequest();

                var response_json, data;
                XHR.onreadystatechange = () => {
                    if (XHR.readyState === 4) {
                        // add edit form to modal
                        modal_body.innerHTML = XHR.response;

                        // get form and send to save
                        const this_edit_form = modal_body.querySelector('.add-edit-form');
                        if (this_edit_form) {
                            this_edit_form.addEventListener("submit", (event) => {
                                event.preventDefault();
                                sendFormData(this_edit_form);
                            });
                        }
                    }
                }

                // Define what happens in case of error
                XHR.addEventListener("error", (event) => {
                  alert('Daten konnten nicht übermittelt werden.');
                });

                // Set up our request
                XHR.open("POST", send_addedit_url, true);
                XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                XHR.send('formname='+form_name+'&id='+edit_id+'&planung='+planung_id+'&botschafter='+botschafter_id+'&datum='+encodeURIComponent(planung_date));
            }
        });
    };
};

/* send, edit, delete response modal forms */
window.addEventListener("load", () => {
    // Get the form element
    //const form = document.getElementById("form_modal_add");
    const forms = document.querySelectorAll(".add-edit-form");
    const einsatz_edit_form = document.getElementById("form_einsatz");

    // modal
    const edit_modal_buttons = document.querySelectorAll('.edit-modal');
    const form_modal = document.querySelector('.modal');

    if (form_modal) {
        // add values to modal form
        form_modal.addEventListener('shown.bs.modal', (e) => {
            var transport, transport_input;
            if (typeof e.relatedTarget !== 'undefined') {
                if (typeof e.relatedTarget.getAttribute("data-transport")) {
                    transport = e.relatedTarget.dataset.transport;
                    transport_input = form_modal.querySelector("#transport_weg");
                    if (transport_input) {
                        transport_input.setAttribute('value', transport);
                    }
                }
            }
        });
    }
    
    // Add 'submit' event handler to modal add(edit->request) forms, modals
    if (forms.length > 0) {
        forms.forEach(function (form) {
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                // check dates
                var isValid = datePreSaveValidation(document.getElementById('einsatz_start'), document.getElementById('einsatz_end'));
                // send form values to save
                if (isValid == true) {
                    sendFormData(form);
                }
            });
        });
    }
    // datum check ändern einsatzdatum
    if (einsatz_edit_form) {
        einsatz_edit_form.addEventListener("submit", (event) => {
            // check dates
            var isValid = datePreSaveValidation(document.getElementById('einsatz_start'), document.getElementById('einsatz_end'));
            // send form values to save
            if (isValid == true) {
                // go on
            } else {
                event.preventDefault();
            }
        });
    };

        // delete entry
    if (delete_buttons) {
        //deleteButtonsClickHandler(delete_buttons);
        var e_id, e_tb, e_field, e_val;
        delete_buttons.forEach(function (del_element) {
            del_element.addEventListener("click", (e) => {
                if (form_planung) {
                    var confirmed = confirm("Wirklich abmelden?");  
                } else {
                    var confirmed = confirm("Eintrag wirklich löschen?");
                }
                if (confirmed) { // delete
                    // get data info
                    e_id = del_element.dataset.id;
                    e_tb = del_element.dataset.tb;
                    // button element übergeben
                    if (form_planung) {
                        e_field = del_element;
                    }
                    // send
                    sendEditData(e_id, e_tb, e_field, e_val, 'delete');
                }
            });
        });
    }

    // delete einsatz
    if (delete_einsatz_btn) {
        delete_einsatz_btn.addEventListener("click", (e) => {
            var confirmed = confirm("Einsatz wirklich löschen?");
            if (confirmed) { // delete
                //window.location.reload();
                // do notthing
            } else {
                e.preventDefault();
            }
        });
    }

    // edit entry
    if (switch_toggles) {
        var s_id, s_tb, s_field, s_val;
        switch_toggles.forEach(function (switch_element) {
            switch_element.addEventListener('change', (e) => {
                // get data info
                s_id = switch_element.dataset.id;
                s_tb = switch_element.dataset.tb;
                s_field = switch_element.dataset.field;

                // active or not
                if (switch_element.checked) {
                    s_val = switch_element.value;
                } else {
                    s_val = switch_element.dataset.inactive;
                }
                // send
                sendEditData(s_id, s_tb, s_field, s_val, 'edit');
            });
        });
    }

    /* autoresize textareas */
    if (form_textareas_fields) {
        addAutoResize(form_textareas_fields);
    }
});